import { render } from "./ErrorPage.vue?vue&type=template&id=4c66bcf6&scoped=true"
import script from "./errorpage.view.js?vue&type=script&lang=js&external"
export * from "./errorpage.view.js?vue&type=script&lang=js&external"

import "./errorpage.css?vue&type=style&index=0&id=4c66bcf6&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c66bcf6"]])

export default __exports__